import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Replace with your actual Google Analytics Measurement ID
const MEASUREMENT_ID = "G-EPSL242C98";

const GoogleAnalytics = () => {
    const location = useLocation();
    const isInitialized = useRef(false);
    const latestLocation = useRef(location);

    // Keep the latest location reference up-to-date
    useEffect(() => {
        latestLocation.current = location;
    }, [location]);

    useEffect(() => {
        // Initialize GA4 with a 2000ms delay to prevent blocking the initial paint of the website
        const timer = setTimeout(() => {
            try {
                ReactGA.initialize(MEASUREMENT_ID);
                isInitialized.current = true;
                
                // Track pageview of the page the user is currently viewing
                const path = latestLocation.current.pathname + latestLocation.current.search;
                ReactGA.send({ hitType: "pageview", page: path });
            } catch (error) {
                console.warn("Failed to initialize Google Analytics:", error);
            }
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        // Send pageview on subsequent route changes only if initialized
        if (isInitialized.current) {
            try {
                ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
            } catch (error) {
                console.warn("Failed to send pageview to Google Analytics:", error);
            }
        }
    }, [location]);

    return null;
};

export default GoogleAnalytics;
